<!--
  Copyright (C) 2021 owner Roman Piontik R.Piontik@mail.ru

  Copyright (C) 2022 Sber

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

  http://www.apache.org/licenses/LICENSE-2.0

  In any derivative products, you must retain the information of
  owner of the original code and provide clear attribution to the project

  https://dochub.info

  The use of this product or its derivatives for any purpose cannot be a secret.


  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.

  Maintainers:
      R.Piontik <r.piontik@mail.ru>

  Contributors:
      R.Piontik <r.piontik@mail.ru> - 2024
-->

<template>
  <div class="place">
    <iframe class="video" v-bind:src="url" />
  </div>
</template>

<script>
  export default {
    name: 'DHYoutube',
    props: {
      src: { type: String, default: '' }
    },
    data() {
      return {
        error: null,
        data: null
      };
    },
    computed: {
      url() {
        let result = this.src;
        if (this.src.toLowerCase().startsWith('https://www.youtube.com/')) {
          const url = new URL(this.src);
          result.type = 'youtube';
          if (url.pathname.startsWith('/embed/')) {
            result = this.src;
          } else if (url.pathname.startsWith('/watch')) {
            result = `https://www.youtube.com/embed/${url.searchParams.get('v')}`;
          }
        } else if (this.src.toLowerCase().startsWith('https://youtu.be/')) {
          result = `https://www.youtube.com/embed/${this.src.slice(16)}`;
        }
        return result;
      }
    }
  };
</script>

<style scoped>
.place {
  width: 100%;
  text-align: center;
}

.video {
  border: none;
  width: 100%;
  max-width: 1024px;
  height: auto;
  aspect-ratio: 16/9;
}
</style>
